import { JSEncrypt } from 'encryptlong'

// 密钥对生成 http://web.chacuo.net/netrsakeypair
// 两对密钥（请求和响应）
const requestPublicKey = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC63quclrb4lUjH8qQgdUxY5+uuucneR/0e/fXsQsCxSXstMgdtmOrHeI+Fb0Poorf7O66cGwfjmD6eJCXezpCjrfe55TMOsXtpZfhDvHa8OK1Rs5F5mlCj94W+HroLhJc8QP0tp/NeYNpCpz17EhwkBkfDUsPTtAgX/KiuUcIMuQIDAQAB'

const responsePrivateKey = "MIICdwIBADANBgkqhkiG9w0BAQEFAASCAmEwggJdAgEAAoGBALlot6/D8J3tNokm\n" +
    "Q63eEcrD0IGsN1OBjkXfcKlwOlxInPvk0+lRcdQtZ5kY737NCAMu5uDN8j+V/Lc8\n" +
    "zepheBASMcF6Y7eJY3HO4oqxlerJ1T8Oc46mORtRi9B6OKyx1ZmKC5P7WHVs3qn8\n" +
    "XG2EhatPsQySirzo4VrTqpIvTQgzAgMBAAECgYB8SXI45MQ7WXShY4Ei4CZVIgZ3\n" +
    "ppY/6C0TMcE4E/9LNXHmeXKEiRAhB37W5hxFh/PDDoG+WM/3R/fsbVorr8Lm/RAE\n" +
    "Qo1kIEnwFH2Yi0M3VxbL6iCXQYN1mhNi2x7v03GV3P4twXzqjWhsvt7E0dP4AIE2\n" +
    "UNXByWdJOxEM5mabQQJBAPQcglYV27GmjNyQV2SzCNyPh+e0u5OEdlwYMeZAarYz\n" +
    "80XC8i/o5LMjOx2eZcimKXgn8E5MrvgmxoQJTTKPdnkCQQDCcFRccf655AEW4fxt\n" +
    "MY7FZuO8UJDpG2T9mpwLyiLILklvrzKjHpEzkq1Fj14uu+dxKA9FjBmlb3CclQhX\n" +
    "UjkLAkBcMTQsLN8m7b6/QigvWMpc+jwajxBUey90QpL94ZArtd0HmMN8wpk06nZW\n" +
    "Dk9kgxSgU30XJTDjeUl57kVgdfwJAkEAnBzqbusL9R6OjVvWe6l9kxsAIHOjVbYs\n" +
    "CL55KbIa6RTY23YUNwnU1U6gFih9GxK9SYo7cMCC2uQ1y1KRRuL6bwJBAJfMhFmt\n" +
    "YMmLFvdgEC1OkbiGDbAk3priA2fbnvOMfs4m1GuqJw93+l03RCDzY3GqMqhjF4ps\n" +
    "4o8RMsHbCGn/Ygo="

// 加密
export function encrypt(txt) {
  const encryptor = new JSEncrypt()
  encryptor.setPublicKey(requestPublicKey) // 设置公钥
  return encryptor.encryptLong(txt) // 对需要加密的数据进行加密
}

// 解密
export function decrypt(txt) {
  const encryptor = new JSEncrypt()
  encryptor.setPrivateKey(responsePrivateKey)
  return encryptor.decryptLong(txt)
}


